import { Component, Input, OnInit } from '@angular/core';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import { DEFAULT_CAROUSEL_SETTINGS } from '../../shared/types/CarouselSettings';
import { ImmersionCarouselComponent } from '../immersion-carousel/immersion-carousel.component';
import { ImmersionCarouselService } from '../immersion-carousel/immersion-carousel.service';
import { CourseContentType } from '../../shared/types/course-content-type';
import { OeAppService } from '../../shared/oe-app.service';
import { GamificationActivityType } from '../../shared/types/gamification-activity-type';
import { PracticeSectionContent } from '../practice-section/practice-section.interface';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DAILY_NEWS_MODAL_TITLE_ID, DailyNewsModalComponent } from '../daily-news-modal/daily-news-modal.component';
import { ImmersionTileModalData } from '../immersion-tile/immersion-tile-modal-data';

@Component({
  selector: 'lp2-news-carousel',
  templateUrl: './news-carousel.component.html',
  styleUrls: ['./news-carousel.component.scss'],
})
export class NewsCarouselComponent
  extends ImmersionCarouselComponent
  implements OnInit, PracticeSectionContent {

  @Input()
  isMobile: boolean;

  get shouldDisplay$() {
    return this.itemsLoaded$.pipe(map((hasLoaded) => hasLoaded && !this.isMobile && (this.immersionItems.length > 0 || this.hasError)));
  }

  @Input()
  set activityPoints(value: Map<GamificationActivityType, number>) {
    this.newsPoints = value
      ? value.get(GamificationActivityType.COMPLETE_PRACTICE_NEWS)
      : 0;
  }

  newsPoints: number;

  public carouselSettings = DEFAULT_CAROUSEL_SETTINGS;

  readonly modalComponent = DailyNewsModalComponent;
  readonly modalData: ImmersionTileModalData = { showCloseButton: false };
  readonly modalTitleId = DAILY_NEWS_MODAL_TITLE_ID;

  constructor(
    public service: ImmersionCarouselService,
    public levelProgressService: LevelProgressService,
    private oeAppService: OeAppService
  ) {
    super(service, levelProgressService, CourseContentType.DAILY_NEWS);
  }

  ngOnInit() {
    this.extraParams = [
      { key: 'contactId', value: this.oeAppService.getPersonData().contactId },
    ];
    super.ngOnInit();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/news-carousel/news-carousel.component.ts